'use client'
import { Typography } from '@mui/material'
import type { ReactNode } from 'react'

// ----------------------------------------------------------------------

interface FieldLabelProps {
  label: ReactNode
  required?: boolean
}

export function FieldLabel({ label, required }: FieldLabelProps) {
  return (
    <Typography
      sx={{
        mb: 0.5,
        fontSize: {
          xs: '12px',
          sm: '14px',
        },
        fontWeight: 300,
      }}
    >
      {label}
      {required && (
        <Typography component={'span'} sx={{ color: 'error.main', fontWeight: 300, lineHeight: 1 }}>
          *
        </Typography>
      )}
    </Typography>
  )
}
